var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPython(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_204_331)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.5766 0.223389C24.2516 0.223389 25.8328 11.2058 25.8328 11.2058L25.8609 22.5839H50.0281V26H16.2621C16.2621 26 0.0566406 24.1621 0.0566406 49.7148C0.0566406 75.2683 14.2012 74.3621 14.2012 74.3621H22.6426V62.5042C22.6426 62.5042 22.1875 48.3597 36.5613 48.3597H60.5309C60.5309 48.3597 73.9977 48.5773 73.9977 35.3445V13.4648C73.9977 13.4648 76.043 0.223389 49.5766 0.223389ZM36.2508 7.87495C36.8219 7.87444 37.3874 7.98654 37.9152 8.20485C38.4429 8.42316 38.9224 8.74338 39.3262 9.1472C39.73 9.55102 40.0502 10.0305 40.2685 10.5582C40.4868 11.0859 40.5989 11.6515 40.5984 12.2226C40.5989 12.7937 40.4868 13.3593 40.2685 13.887C40.0502 14.4147 39.73 14.8942 39.3262 15.298C38.9224 15.7018 38.4429 16.0221 37.9152 16.2404C37.3874 16.4587 36.8219 16.5708 36.2508 16.5703C35.6797 16.5708 35.1141 16.4587 34.5864 16.2404C34.0587 16.0221 33.5792 15.7018 33.1754 15.298C32.7716 14.8942 32.4513 14.4147 32.233 13.887C32.0147 13.3593 31.9026 12.7937 31.9031 12.2226C31.9026 11.6515 32.0147 11.0859 32.233 10.5582C32.4513 10.0305 32.7716 9.55102 33.1754 9.1472C33.5792 8.74338 34.0587 8.42316 34.5864 8.20485C35.1141 7.98654 35.6797 7.87444 36.2508 7.87495V7.87495Z",
    fill: "url(#paint0_linear_204_331)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2956 99.4632C75.6206 99.4632 74.0394 88.4808 74.0394 88.4808L74.0113 77.103H49.8437V73.687H83.6097C83.6097 73.687 99.8152 75.5249 99.8152 49.9714C99.8152 24.4183 85.6706 25.3245 85.6706 25.3245H77.2292V37.182C77.2292 37.182 77.6843 51.3265 63.3105 51.3265H39.341C39.341 51.3265 25.8742 51.1089 25.8742 64.3421V86.2222C25.8742 86.2222 23.8292 99.4632 50.2953 99.4632H50.2956ZM63.6214 91.8124C63.0503 91.8129 62.4848 91.7008 61.957 91.4825C61.4293 91.2642 60.9498 90.944 60.546 90.5402C60.1422 90.1363 59.822 89.6569 59.6037 89.1291C59.3854 88.6014 59.2733 88.0358 59.2738 87.4648C59.2732 86.8936 59.3853 86.328 59.6036 85.8003C59.8218 85.2725 60.1421 84.793 60.5459 84.3891C60.9497 83.9852 61.4292 83.665 61.9569 83.4467C62.4847 83.2283 63.0503 83.1162 63.6214 83.1167C64.1925 83.1162 64.7581 83.2283 65.2858 83.4466C65.8135 83.6649 66.293 83.9851 66.6968 84.389C67.1006 84.7928 67.4209 85.2723 67.6392 85.8C67.8575 86.3277 67.9696 86.8933 67.9691 87.4644C67.9696 88.0355 67.8575 88.601 67.6392 89.1287C67.4209 89.6565 67.1006 90.1359 66.6968 90.5398C66.293 90.9436 65.8135 91.2638 65.2858 91.4821C64.7581 91.7004 64.1925 91.8125 63.6214 91.812V91.8124Z",
    fill: "url(#paint1_linear_204_331)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_204_331",
    x1: 9.64341,
    y1: 9.14942,
    x2: 59.0807,
    y2: 58.0936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387EB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#366994"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_204_331",
    x1: 39.988,
    y1: 40.5784,
    x2: 93.078,
    y2: 90.7661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC331"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_204_331"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 99.6094,
    fill: "white",
    transform: "translate(0 0.195312)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPython);
export default __webpack_public_path__ + "static/media/python.ba695b61aca8cf44b75bb098d269482b.svg";
export { ForwardRef as ReactComponent };